import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
// import JwtService from "@/common/jwt.service";
import { BASE_URL } from "../../config";

const ApiService = {
	init() {
		Vue.use(VueAxios, axios);
		Vue.axios.defaults.baseURL = BASE_URL;
	},

	post(endpoint, payload, headers, returnNoTransform = false) {
		return Vue.axios
			.post(endpoint, payload, headers)
			.then(response => {
				return response.data;
			})
			.catch(err => {
				if (returnNoTransform) {
					throw err;
				}
				throw new Error(err);
			});
	},

	get(endpoint, headers) {
		return Vue.axios
			.get(endpoint, { headers })
			.then(response => response.data)
			.catch(err => {
				throw err;
			});
	},

	put(endpoint, payload, headers) {
		return Vue.axios
			.put(endpoint, payload, { headers })
			.then(response => {
				return response.data;
			})
			.catch(err => {
				console.log("Error ", err);
				throw err;
			});
	}
};

export default ApiService;
